import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, professionalServiceJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/contacto")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Contacto Shugert: Agencia Shopify de alta gama",
    description: "Habla con el equipo de Shugert sobre tu proyecto Shopify. Respondemos en 1 día hábil y cotizamos alcance, plazo y precio por adelantado.",
    path: "/es/contacto",
    altPath: alternatePath("/es/contacto", "en"),
    jsonLd: [professionalServiceJsonLd("es"), breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Contacto", path: "/es/contacto" }])],
  }),
});
